'use client';
import React, { useCallback, useContext, useState } from 'react';
import { MiniCartContextShape } from './types';

const MiniCartContext = React.createContext<MiniCartContextShape>({
  show() {},
  isOpen: false,
  hide() {},
});

const MiniCartProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState(false);

  const show = useCallback(() => {
    setIsOpen(true);
  }, []);

  const hide = useCallback(() => {
    setIsOpen(false);
  }, []);

  return <MiniCartContext.Provider value={{ show, hide, isOpen }}>{children}</MiniCartContext.Provider>;
};

export default MiniCartProvider;

export const useMiniCart = () => useContext(MiniCartContext);
